var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    stroke: "#FFFFFF",
    strokeWidth: 0.188564,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M11.6123 4.25391C11.2826 4.25391 11.0234 4.51303 11.0234 4.8428V10.1428C11.0234 10.4726 11.2826 10.7317 11.6123 10.7317H14.5568C14.8866 10.7317 15.1457 10.4726 15.1457 10.1428C15.1457 9.81304 14.8866 9.55392 14.5568 9.55392H12.2012V4.8428C12.2012 4.51303 11.9421 4.25391 11.6123 4.25391Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "circle",
    d: "M3.53249 10.8462C3.6503 10.964 3.79161 11.0112 3.95641 11.0112C4.12138 11.0112 4.26268 10.964 4.38033 10.8462L6.73589 8.49065C6.97151 8.25503 6.97151 7.87825 6.73589 7.66612C6.50027 7.43049 6.12349 7.43049 5.91136 7.66612L4.54526 8.98536C4.68657 5.21637 7.79598 2.17778 11.6119 2.17778C15.4985 2.17778 18.6786 5.35788 18.6786 9.24447C18.6786 13.1311 15.4985 16.3112 11.6119 16.3112C11.2822 16.3112 11.0231 16.5703 11.0231 16.9001C11.0231 17.2298 11.2822 17.4889 11.6119 17.4889C16.1582 17.4889 19.8564 13.7906 19.8564 9.24447C19.8564 4.69832 16.1581 1 11.6119 1C7.13638 1 3.50881 4.5805 3.36748 9.00892L2.00125 7.64269C1.76563 7.40707 1.38884 7.40707 1.17672 7.64269C0.941094 7.87831 0.941094 8.25509 1.17672 8.46722L3.53249 10.8462Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportHistory);
export default __webpack_public_path__ + "static/media/import-history.e23aec8966fff1adb05dafaa453a2544.svg";
export { ForwardRef as ReactComponent };